import * as actionTypes from '../../constants/actionTypes';

export function createDefaultState() {
    return {
        date: new Date(),
        searchOpen: false,
        search: '',
        searchEntered: ''
    };
}

function assign(state, newFields) { return Object.assign({}, state, newFields); }

export function reduce(state, action) {
    switch (action.type) {
        case actionTypes.SET_FILTER_DATE:
            return assign(state, { date: action.date });
        case actionTypes.SET_FILTER_SEARCH:
            return assign(state, { search: action.search });
        case actionTypes.SET_FILTER_SEARCH_ENTERED:
            return assign(state, {searchEntered: state.search });
        case actionTypes.TOGGLE_FILTER_SEARCH:
            return assign(state, { searchOpen: !state.searchOpen, search: '' });
        case actionTypes.CLEAR_FILTER:
            return createDefaultState();
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/onDemand/ordersFilterReducer.js